// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3rGEK","resendInfoText":"OnGoingPaymentBox_resendInfoText__1bwF0"};